import Marquee from "react-fast-marquee";
import { Car } from "lucide-react";

const carBrands = [
  "PEUGEOT",
  "RENAULT",
  "BMW",
  "MERCEDES",
  "AUDI",
  "VOLKSWAGEN",
  "CITROËN",
  "FIAT",
  "FORD",
  "TOYOTA",
  "OPEL",
  "DACIA",
];

const insurances = [
  "AXA",
  "ALLIANZ",
  "MAIF",
  "MACIF",
  "MATMUT",
  "GMF",
  "GROUPAMA",
  "MMA",
  "GENERALI",
  "DIRECT ASSURANCE",
  "APRIL",
  "LA BANQUE POSTALE",
];

export const TrustMarquee = () => {
  return (
    <section
      id="partenaires"
      data-testid="trust-section"
      className="relative bg-[#0A0A0A] border-y border-white/10 py-20 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#007AFF] mb-4">
              — Écosystème
            </div>
            <h2
              data-testid="trust-title"
              className="font-heading text-3xl md:text-5xl font-black uppercase tracking-tighter max-w-2xl"
            >
              Soutenu par les<br />
              <span className="text-[#0055A4]">assurances</span> & les{" "}
              <span className="text-[#EF4135]">constructeurs</span>
            </h2>
          </div>
          <p className="text-sm text-white/60 max-w-md leading-relaxed">
            Nos techniques DSP respectent strictement les protections d'usine.
            Agréé par les principaux acteurs de l'automobile et de l'assurance
            en France.
          </p>
        </div>
      </div>

      {/* Car brands marquee */}
      <div className="mb-10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-4">
          <div className="text-[10px] uppercase tracking-[0.4em] text-white/40">
            Constructeurs automobiles
          </div>
        </div>
        <Marquee
          speed={40}
          gradient
          gradientColor="#0A0A0A"
          gradientWidth={120}
          pauseOnHover
        >
          {carBrands.concat(carBrands).map((name, i) => (
            <div
              key={`car-${i}`}
              className="flex items-center gap-4 mx-10 text-white/50 hover:text-white transition-colors"
            >
              <Car className="w-8 h-8 md:w-10 md:h-10" strokeWidth={1.5} />
              <span className="font-heading font-black text-xl md:text-3xl uppercase tracking-[0.15em]">
                {name}
              </span>
            </div>
          ))}
        </Marquee>
      </div>

      {/* Insurances marquee */}
      <div>
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-4">
          <div className="text-[10px] uppercase tracking-[0.4em] text-white/40">
            Compagnies d'assurance
          </div>
        </div>
        <Marquee
          speed={30}
          direction="right"
          gradient
          gradientColor="#0A0A0A"
          gradientWidth={120}
          pauseOnHover
        >
          {insurances.concat(insurances).map((name, i) => (
            <div
              key={`ins-${i}`}
              className="mx-6 px-6 py-3 border border-white/15 text-white/60 hover:text-white hover:border-white/40 transition-colors"
            >
              <span className="font-heading font-black text-lg md:text-2xl uppercase tracking-[0.2em]">
                {name}
              </span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
